import { FormattedMessage } from 'react-intl'

import DeviceMetricsDoughnutChart from '@/pages/SpaceAnalyticsPage/charts/DeviceMetricsDoughnutChart'
import messages from '@/pages/SpaceAppBuilder/AnalyticsPage/DeviceMetricsSection/messages'

const CHART_COLORS = ['#26beac', '#dd3f67', '#fcd145', '#2bb3e4']

interface MemberActivityByDeviceProps {
  byDeviceData: any
}

const MemberActivityByDevice = ({ byDeviceData }: MemberActivityByDeviceProps) => {
  return (
    <div className="sub-section">
      <div className="metric-card-subheader">
        <h3>
          <FormattedMessage {...messages.notificationActivityByDeviceSectionTitle} />
        </h3>
      </div>
      {byDeviceData.length > 0 ? (
        <DeviceMetricsDoughnutChart className="doughnut-chart" data={byDeviceData} colors={CHART_COLORS} />
      ) : (
        <p className="flex-center">
          <FormattedMessage {...messages.noActivityMetrics} />
        </p>
      )}
    </div>
  )
}

MemberActivityByDevice.displayName = 'MemberActivityByDevice'

export default MemberActivityByDevice
